import { AvcoreSubcribeStreamApiCredentials } from "@common/domain";
import { fromEvent } from "rxjs";
import { takeUntil, tap } from "rxjs/operators";
import { StreamData } from "../../actions";
import { PlainExtendedMediaStream } from "../../extended-media-stream";
import { assert } from "../../utils";
import { ConferenceApi } from "./ConferenceApi";

export class SubscribeConferenceApi extends ConferenceApi {
  private _origin: null | MediaStream = null;
  private _subscribed = false;

  constructor(
    streamData: StreamData,
    streamApiCredentials: AvcoreSubcribeStreamApiCredentials,
    logger: (...args: unknown[]) => void
  ) {
    super(streamData, streamApiCredentials, logger);
  }

  async subscribe(): Promise<PlainExtendedMediaStream> {
    assert(
      !this._subscribed,
      "Stream single subscribe invariant is broken-down"
    );

    this._subscribed = true;

    this._origin = await super.subscribe1();

    const stream = new PlainExtendedMediaStream(this._origin);

    fromEvent<MediaStreamTrackEvent>(this._conferenceApi, "addtrack")
      .pipe(
        tap((_) => {
          stream.addTrack(_.track);
        }),
        takeUntil(this._destroy$)
      )
      .subscribe();

    fromEvent<MediaStreamTrackEvent>(this._conferenceApi, "removetrack")
      .pipe(
        tap((_) => {
          stream.removeTrack(_.track);
        }),
        takeUntil(this._destroy$)
      )
      .subscribe();

    return stream;
  }

  override async destroy() {
    await super.destroy();

    this._origin?.getTracks().forEach((_) => {
      this._origin?.removeTrack(_);
      _.stop();
    });
  }
}
